
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buero/auszeichnungen",
      function () {
        return require("private-next-pages/buero/auszeichnungen/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buero/auszeichnungen"])
      });
    }
  